import React, { Component } from 'react';
import styles from './App.module.css';
import ModeSelection from './containers/ModeSelection';
import TeamCreation from './containers/TeamCreation';
import Game from './containers/Game';
import Help from './containers/Help';
import Finish from './containers/Finish';
import * as constants from './constants';
import clownhorn from './assets/clownhorn.mp3';

class App extends Component {

  state = {
    container: 'modeSelection',
    kids: false,
    vocabulary: [],
    teams: [
      {
        id: 'blue',
        name: constants.TEXT1,
        score: 0
      },
      {
        id: 'pink',
        name: constants.TEXT2,
        score: 0
      }
    ],
    teamPlays: 0,
    card: {
      drawn: false,
      words: [],
      guessed: 0
    },
    timer: {
      sec: 180,
      paused: true,
      pausedFlag: false
    },
    turn: 1,
    windowWidth: 0
  }  

  // countdown
  time = 0;

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowWidth);
    this.updateWindowWidth();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowWidth);
  }

  // window size
  updateWindowWidth = () => {
    this.setState({windowWidth: window.innerWidth});
  }

  // container
  changeContainer = (c) => {
    this.setState({ container: c })
  }

  resetGame = () => {
    this.setState({
      kids: false,
      vocabulary: [],
      teams: [
        {
          id: 'blue',
          name: constants.TEXT1,
          score: 0
        },
        {
          id: 'pink',
          name: constants.TEXT2,
          score: 0
        }
      ],
      teamPlays: 0,
      card: {
        drawn: false,
        words: [],
        guessed: 0
      },
      timer: {
        sec: 180,
        paused: true,
        pausedFlag: false
      },
      turn: 1,
      container: 'modeSelection',
    });
    clearInterval(this.time);
    this.time = 0;
  }

  // MODE SELECTION

  chooseGameMode = (k) => {
    this.importVocabulary(k);
    this.setState({ kids: k })
  };

  // import words based on language and game mode
  importVocabulary = (kids) => {
    let path = './assets/' + constants.DATAFILENAME;
    if (kids) path += '-easy';
    path += '.json';
    import(`${path}`).then(
      data => this.setState({ vocabulary: data.default.vocabulary })
    )
  }

  // TEAM CREATION

  addTeam = () => {
    const teams = [...this.state.teams];
    let t = null;
    if (teams.length < 4) {
      if (teams.length === 2) {
        t = {
          id: 'green',
          name: constants.TEXT3,
          score: 0
        }
      } else {
        t = {
          id: 'orange',
          name: constants.TEXT4,
          score: 0
        }
      }
    }
    teams.push(t);
    this.setState({ teams: teams });
  }

  removeTeam = () => {
    const teams = [...this.state.teams];
    teams.pop();
    this.setState({ teams: teams });
  }

  handleTeamNameChange = (event, id) => {
    const teams = [...this.state.teams];
    const teamIndex = teams.findIndex(t => t.id === id);
    const team = { ...teams[teamIndex] };
    team.name = event.target.value;
    teams[teamIndex] = team;
    this.setState({ teams: teams });
  }

  // if team name is empty revert to default
  checkTeamName = () => {
    const teams = this.state.teams.map((t) => {
      if (t.name.trim() === '') {
        if (t.id === 'blue') t.name = constants.TEXT1;
        if (t.id === 'pink') t.name = constants.TEXT2;
        if (t.id === 'green') t.name = constants.TEXT3;
        if (t.id === 'orange') t.name = constants.TEXT4;
      }
      return t;
    });
    this.setState({ teams: teams });
  }

  // GAME

  resetCard = () => {
    this.setState(
      {
        card: {
          drawn: false,
          words: [],
          guessed: 0
        }
      });
  }

  nextTeam = () => {
    let p = this.state.teamPlays;
    let t = this.state.turn;
    if (p === this.state.teams.length - 1) {
      // if it's end of the game (5 turns played)
      if (t === 5) {
        // go to Finish container
        this.changeContainer('finish');
      }
      else {
        p = 0;
        t++;
      }
    }
    else {
      p++;
    }
    this.resetCard();
    this.resetTimer();
    this.setState({ teamPlays: p, turn: t });
  }

  // start countdown every 1 second
  startTimer = (flag) => {
    if (this.state.timer.sec > 0 && this.state.timer.paused) {
      this.time = setInterval(() => {
        const seconds = this.state.timer.sec - 1;
        const timer = { ...this.state.timer, sec: seconds, paused: false, pausedFlag: flag };
        this.setState({ timer: timer });

        if (seconds === 0) {
          const timer = { ...this.state.timer, paused: true, pausedFlag: flag };
          this.setState({ timer: timer });
          clearInterval(this.time);
          const audio = new Audio(clownhorn);
          audio.play();
        }
      }, 1000);
    }
  }

  pauseTimer = (flag) => {
    const timer = { ...this.state.timer, paused: true, pausedFlag: flag };
    this.setState({ timer: timer });
    clearInterval(this.time);
  }

  resetTimer = () => {
    const timer = { ...this.state.timer, sec: 180, paused: true, pausedFlag: false };
    this.setState({ timer: timer });
    clearInterval(this.time);
    this.time = 0;
  }

  // draw card, generate random 5 word array
  drawCard = () => {
    const random5 = [];
    const words = [];
    for (let i = 0; i < 5; i++) {
      let n;
      do {
        n = Math.floor(Math.random() * this.state.vocabulary.length);
      } while (random5.includes(n));
      words.push({ text: this.state.vocabulary[n], guessed: false });
      random5.push(n);
    }
    this.setState({ card: { drawn: true, words: words, guessed: 0 } });
    this.startTimer();
  }

  // if a word is guessed (clicked)
  guess = (id) => {
    const card = { ...this.state.card };
    // deep clone array of objects
    let teams = JSON.parse(JSON.stringify(this.state.teams));

    // guessed
    if (!card.words[id].guessed) {
      card.guessed++;
      card.words[id].guessed = true;
      if (card.guessed === 5) {
        this.pauseTimer();
      }
      teams[this.state.teamPlays].score++;
      this.setState({ teams: teams });
    }
    // revert guess 
    else {
      card.guessed--;
      card.words[id].guessed = false;
      if (card.guessed === 4) {
        this.startTimer();
      }
      teams[this.state.teamPlays].score--;
      this.setState({ teams: teams });
    }
    this.setState({ card: card });
  }

  render() {
    let container = null;
    if (this.state.container === 'modeSelection') {
      container = <ModeSelection
        changeContainer={this.changeContainer}
        chooseGameMode={this.chooseGameMode} />;
    } else if (this.state.container === 'teamCreation') {
      container = <TeamCreation
        changeContainer={this.changeContainer}
        handleTeamNameChange={this.handleTeamNameChange}
        checkTeamName={this.checkTeamName}
        teams={this.state.teams}
        addTeam={this.addTeam}
        removeTeam={this.removeTeam} />
    } else if (this.state.container === 'game') {
      container = <Game
        changeContainer={this.changeContainer}
        kids={this.state.kids}
        teams={this.state.teams}
        teamPlays={this.state.teamPlays}
        timer={this.state.timer}
        startTimer={this.startTimer}
        pauseTimer={this.pauseTimer}
        resetTimer={this.resetTimer}
        nextTeam={this.nextTeam}
        card={this.state.card}
        drawCard={this.drawCard}
        guess={this.guess}
        resetGame={this.resetGame}
        windowWidth={this.state.windowWidth}
      />
    } else if (this.state.container === 'help') {
      container = <Help
        changeContainer={this.changeContainer}
        startTimer={this.startTimer}
        pausedFlag={this.state.timer.pausedFlag}
      />
    } else if (this.state.container === 'finish') {
      container = <Finish
        teams={this.state.teams}
        resetGame={this.resetGame}
      />
    }
    return (
      <div className={styles.app}>
        <div className={styles.buffer}></div>
        {container}
      </div>
    );
  }
}

export default App;
